var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col"},[_c('div',{staticClass:"font-bold"},[_vm._v(" "+_vm._s(_vm.busStopTypeDisplay)+" ")]),_c('span',{staticClass:"ml-4"},[_vm._v(_vm._s(_vm.busStopDisplay))])])
}
var staticRenderFns = []

export { render, staticRenderFns }